<template>
  <div>
    <!-- <el-dialog title="筛选条件" :visible="true" width="80%" @close="dialogCloss"> -->
    <el-form :inline="true" label-position="right" label-width="140px" ref="form">
      <!-- 表单 -->
      <!-- <el-row class="dialog-small-title">
          <el-col :span="24">筛选条件</el-col>
      </el-row>-->
      <el-form-item label="* 筛选项目" style="width:100%;">
        <div style="width:600%;">
          <el-checkbox-group v-model="projectIds" size="mini" style="margin-left:30px;">
            <template v-for="(projectItem, projectIndex) in projectList">
              <el-checkbox :key="projectIndex" :label="projectItem.id" :checked="projectList.length===1&&projectIndex===0">{{projectItem.organizeName}}</el-checkbox>
            </template>
          </el-checkbox-group>
        </div>
      </el-form-item>
      <template v-for="(dsItem, dsIndex) in conditionsSources">
        <el-card v-if="isShowCard(dsItem)" :key="dsIndex" class="ds-card">
          <div slot="header">
            <span>{{dsItem.title.split("$")[0]}}</span>
          </div>
          <template v-for="(fieldItem, fieldIndex) in dsItem.children">
            <el-form-item v-if="fieldItem.select&&fieldItem.columnPro!=='date'&&fieldItem.conditionType!=='bt'&&fieldItem.key!==defaultSelectKey" :key="fieldIndex" :label="fieldItem.title">
              <!-- string 类型  等于 -->
              <div v-if="fieldItem.columnPro==='string'&&fieldItem.conditionType==='eq'">
                <el-input :placeholder="conditionMsg[fieldItem.columnPro]" v-model="fieldItem.value">
                  <template slot="prepend">{{conditionMsg[fieldItem.conditionType]}}</template>
                </el-input>
              </div>
              <!-- string 类型  等于 -->
              <!-- string 类型  模糊查询 -->
              <div v-if="fieldItem.columnPro==='string'&&fieldItem.conditionType==='like'">
                <el-input :placeholder="conditionMsg[fieldItem.columnPro]" v-model="fieldItem.value">
                  <template slot="prepend">{{conditionMsg[fieldItem.conditionType]}}</template>
                </el-input>
              </div>
              <!-- string 类型  模糊查询 -->
              <!-- number 类型  等于 大于 小于 -->
              <div v-if="fieldItem.columnPro==='number'&&fieldItem.conditionType!=='bt'">
                <el-input :placeholder="conditionMsg[fieldItem.columnPro]" v-model="fieldItem.value">
                  <template slot="prepend">{{conditionMsg[fieldItem.conditionType]}}</template>
                </el-input>
              </div>
              <!-- number 类型  等于 大于 小于 -->
              <!-- number 类型  区间 -->
              <div v-if="fieldItem.columnPro==='number'&&fieldItem.conditionType==='bt'" class="condition-number-bt">
                <el-input v-model="fieldItem.value" :placeholder="conditionMsg[fieldItem.columnPro]"></el-input>&nbsp;&nbsp;至&nbsp;
                <el-input v-model="fieldItem.endValue" :placeholder="conditionMsg[fieldItem.columnPro]"></el-input>
              </div>
              <!-- number 类型  区间 -->
              <!-- date 类型  等于 大于 小于 -->
              <div v-if="fieldItem.columnPro==='date'&&fieldItem.conditionType!=='bt'" class="condition-number-one">
                <div class="el-input-group__prepend">{{conditionMsg[fieldItem.conditionType]}}</div>
                <el-date-picker v-model="fieldItem.value" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
              </div>
              <!-- date 类型  等于 大于 小于 -->
            </el-form-item>
            <el-form-item
              v-if="fieldItem.select&&fieldItem.columnPro==='date'&&fieldItem.conditionType==='bt'&&fieldItem.key!==defaultSelectKey"
              :key="fieldIndex"
              :label="fieldItem.title"
              style="width:695px;"
            >
              <!-- date 类型  区间 -->
              <div v-if="fieldItem.columnPro==='date'&&fieldItem.conditionType==='bt'" class="condition-number-one condition-number-two">
                <div class="el-input-group__prepend">{{conditionMsg[fieldItem.conditionType]}}</div>
                <el-date-picker
                  v-model="fieldItem.value"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始"
                  end-placeholder="结束"
                  :picker-options="dateOptions"
                  :editable="false"
                  value-format="yyyy-MM-dd 00:00:00"
                ></el-date-picker>
              </div>
              <!-- date 类型  区间 -->
            </el-form-item>
          </template>
        </el-card>
      </template>
      <!-- 表单 -->
      <el-form-item class="dialog-footer" :inline="false">
        <el-button type="primary" size="medium" @click="submit">提交</el-button>
      </el-form-item>
    </el-form>
    <!-- </el-dialog> -->
  </div>
</template>
<script>
import { IsNullOrEmpty, DateFormat } from "@/utils/m-utils";
import { getTemplateCondition, reportFormExportAsyncExcel, getUserProjectsOfTemplate } from "@/api/api";
import { _reportFormDesignerServerUrl } from "@/utils/axios/request";
import { Loading } from "element-ui";

export default {
  props: {
    temp: {
      //{name:"",id:""}
      type: Object,
      default: function() {
        return {};
      }
    },
    //导出方式  preview预览  export同步导出    asyncExport异步导出
    conditionType: {
      type: String,
      default: "preview"
    }
  },
  data() {
    return {
      conditionMsg: {
        eq: "等于",
        gt: "大于",
        lt: "小于",
        bt: "区间",
        like: "模糊查询",
        string: "字符",
        date: "日期",
        number: "数字"
        // eq: "=",
        // gt: ">",
        // lt: "<",
        // bt: "区间"
      },
      conditionsSources: [], //条件数据源
      dateOptions: {
        // 禁用今天之后的日期
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: this.$dateOptions.shortcuts
      },
      projectIds: [], //选中的项目id
      defaultSelectKey: "project_id", //默认必选条件  project_id
      projectList: [] //当前用户可导出的项目列表
    };
  },
  methods: {
    //获取当前用户可以导出的项目列表
    async getUserProjectsOfTemplate() {
      const jsonData = await getUserProjectsOfTemplate({ tempId: this.temp.id });
      this.projectList = jsonData.data;
    },
    //获取模版条件
    async getTemplateCondition() {
      const jsonData = await getTemplateCondition({ id: this.temp.id + "" });
      this.conditionsSources = IsNullOrEmpty(jsonData.data) ? [] : JSON.parse(jsonData.data);
      this.checkConditionCount();
    },
    //判断是否显示card   如果这个ds下没有任何字段选中，则不显示这个card
    isShowCard(dsItem) {
      let isShow = false;
      for (let i = 0; i < dsItem.children.length; i++) {
        const item = dsItem.children[i];
        if (item.select && item.key !== this.defaultSelectKey) {
          isShow = true;
          break;
        }
      }
      return isShow;
    },
    //提交
    submit() {
      if (this.projectIds.length === 0) {
        this.$message.error("请选择筛选项目");
        return;
      }
      let conditionParams = [];
      let conditionsSources = this.conditionsSources;

      //  [{ dsName: "原材料入库管理$1", dsKey: "", fieldName: "申请人", fieldKey: "apply_user_id", conditionType: "eq", value: "向勤勇" }]
      //序列化参数
      conditionsSources.forEach(dsItem => {
        dsItem.children.forEach(fieldItem => {
          if (fieldItem.select) {
            let value = "";
            //处理区间的值
            if (fieldItem.conditionType === "bt" && fieldItem.key !== this.defaultSelectKey) {
              if (fieldItem.columnPro === "number") {
                if (!IsNullOrEmpty(fieldItem.endValue)) {
                  value = fieldItem.value + "$" + fieldItem.endValue;
                }
              }
              if (fieldItem.columnPro === "date") {
                if (!IsNullOrEmpty(fieldItem.value)) {
                  let endValue = fieldItem.value[1].split(" ")[0] + " 23:59:59";
                  value = fieldItem.value[0] + "$" + endValue;
                }
              }
            }
            //处理project_id
            else if (fieldItem.conditionType === "eq" && fieldItem.key === this.defaultSelectKey) {
              value = this.projectIds.join("$");
            } else {
              value = fieldItem.value;
            }
            conditionParams.push({
              dsName: dsItem.title,
              dsKey: dsItem.key,
              fieldName: fieldItem.title,
              fieldKey: fieldItem.key,
              conditionType: fieldItem.conditionType,
              value: value
            });
          }
        });
      });
      switch (this.conditionType) {
        case "preview":
          this.getPreview(conditionParams);
          break;
        case "export":
          this.getExportExcel(conditionParams);
          break;
        case "asyncExport":
          this.getExportAsyncExcel(conditionParams);
          break;
        default:
          this.getPreview(conditionParams);
          break;
      }
    },
    //请求预览
    getPreview(condition) {
      let loading = Loading.service({
        lock: true,
        text: "",
        customClass: "rc-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      let params = {
        id: this.temp.id + "",
        condition
      };
      let request = new XMLHttpRequest();
      request.onreadystatechange = () => {
        if (request.readyState == 4 && request.status == 200) {
          let fileName = this.temp.name || "报表预览";// 工友智能-报表预览
          let blob = new Blob([request.response], { type: "application/pdf" });
          // if (window.navigator.msSaveOrOpenBlob) {
          //   navigator.msSaveBlob(blob, fileName);
          // } else {
          //   window.open(window.URL.createObjectURL(blob));
          // }
          window.open(window.URL.createObjectURL(blob));
          this.conditionComplate();
          loading.close();
          this.$emit("conditionComplate");
        } else if (request.readyState == 4 && request.responseText != "") {
          this.conditionComplate();
          loading.close();
          this.$emit("conditionComplate");
          this.$message.error("加载预览失败");
        }
      };
      request.open("POST", _reportFormDesignerServerUrl + "/report-form-design/report/load", true);
      request.responseType = "blob";
      request.setRequestHeader("Accept", "application/json, text/plain, */*");
      request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      request.setRequestHeader("token", sessionStorage.getItem("accessToken"));
      request.send(JSON.stringify(params));
    },
    //同步导出excel
    getExportExcel(condition) {
      let loading = Loading.service({
        lock: true,
        text: "",
        customClass: "rc-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      let params = {
        id: this.temp.id + "",
        condition
      };
      let request = new XMLHttpRequest();
      request.onreadystatechange = () => {
        if (request.readyState == 4 && request.status == 200) {
          let fileName = (this.temp.name || "未命名") + ".xlsx";
          let blob = new Blob([request.response], { type: "application/x-xlsx" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.conditionComplate();
          loading.close();
          this.$emit("conditionComplate");
        } else if (request.readyState == 4 && request.responseText != "") {
          this.conditionComplate();
          loading.close();
          this.$emit("conditionComplate");
          this.$message.error("加载预览失败");
        }
      };
      request.open("POST", _reportFormDesignerServerUrl + "/report-form-design/report/exportExcel", true);
      request.responseType = "blob";
      request.setRequestHeader("Accept", "application/json, text/plain, */*");
      request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      request.send(JSON.stringify(params));
    },
    //异步导出Excel
    async getExportAsyncExcel(condition) {
      let params = {
        id: this.temp.id + "",
        condition
      };
      const jsonData = await reportFormExportAsyncExcel(params);
      this.$message.success(jsonData.msg);
      this.asyncExportComplate();
      this.$emit("conditionComplate");
    },
    //获取该模版有没有条件
    checkConditionCount() {
      let hasCondition = false;
      for (let i = 0; i < this.conditionsSources.length; i++) {
        const dsItem = this.conditionsSources[i];
        for (let j = 0; j < dsItem.children.length; j++) {
          const fieldItem = dsItem.children[j];
          if (fieldItem.select) {
            hasCondition = true;
            break;
          }
        }
      }
      //模版未设置条件
      if (!hasCondition) {
        // this.$message("该模板未设置条件");
        this.submit(); //直接提交预览
        this.$nextTick(() => {
          this.$emit("conditionComplate"); //关闭上级页面dialog容器
        });
      }
      return hasCondition;
    },
    //调用iframe父页面的提交方法，提交跨域监听  条件提交完成
    conditionComplate() {
      window.parent.postMessage({ conditionComplate: true }, "*");
    },
    //调用iframe父页面的提交方法，提交跨域监听  异步导出提交完成
    asyncExportComplate() {
      window.parent.postMessage({ asyncExportComplate: true }, "*");
    }
  },
  mounted() {
    this.getTemplateCondition();
    this.getUserProjectsOfTemplate();
    //调用iframe父页面的监听事件   条件列表页面加载完成
    window.parent.postMessage({ conditionLoad: true }, "*");
  }
};
</script>
<style lang="scss">
.ds-card {
  margin-bottom: 20px;

  .el-card__header {
    padding: 8px 15px !important;
  }

  .el-input-group__prepend {
    padding: 0 8px !important;
  }

  //两个输入框
  .condition-number-bt {
    .el-input {
      width: 42% !important;
    }
  }
  // 单个日期选择框
  .condition-number-one {
    display: flex;
    .el-input-group__prepend {
      width: 26px;
      height: 30px;
    }

    .el-date-editor {
      width: calc(100% - 40px);
    }
  }

  //两个日期框
  .condition-number-two {
    width: 350px;
  }
}
.dialog-footer {
  margin-top: 30px;
  width: 100%;
  display: block;
  text-align: center;
}
.el-form--inline .el-form-item--small .el-form-item__content {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/report-form/report-form-conditions.vue